"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var Policy_1 = require("../api/Policy");
var UrlParam_1 = require("../helpers/UrlParam");
var PolicyConnector = /** @class */ (function () {
    function PolicyConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Get policies
     * @param policyStatus
     * @param partyId
     */
    PolicyConnector.prototype.getPolicies = function (policyStatus, partyId, onlyMasterPolicies) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        UrlParam_1.appendParam(params, 'policyStatus', policyStatus);
        if (onlyMasterPolicies) {
            UrlParam_1.appendParam(params, 'onlyMasterPolicies', 'true');
        }
        return fetchRequest_1.fetchWrappedRequest(Policy_1.getPoliciesUsingGET(params), this.baseUrl);
    };
    /**
     * Get policies including pagination
     * @param policyStatus
     * @param partyId
     * @param apiParams
     */
    PolicyConnector.prototype.getPoliciesWithPagination = function (policyStatus, partyId, onlyMasterPolicies, apiParams) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'partyId', partyId);
        UrlParam_1.appendParam(params, 'policyStatus', policyStatus);
        UrlParam_1.appendDefaultParams(params, apiParams);
        if (onlyMasterPolicies) {
            UrlParam_1.appendParam(params, 'onlyMasterPolicies', 'true');
        }
        return fetchRequest_1.fetchRequestWithPagination(Policy_1.getPoliciesUsingGET(params), this.baseUrl);
    };
    /**
     * Get underlying policies from a master policy including pagination
     * @param masterPolicyNo
     * @param apiParams
     */
    PolicyConnector.prototype.getUnderLyingPoliciesWithPagination = function (filter) {
        var params = new URLSearchParams();
        UrlParam_1.appendDefaultParams(params, filter.apiParams);
        UrlParam_1.appendParam(params, 'searchCivilRegCode', filter.searchCivilRegCode);
        UrlParam_1.appendParam(params, 'flexFieldSearchParams', filter.flexFieldSearchParams);
        UrlParam_1.appendParam(params, 'searchName', filter.searchName);
        UrlParam_1.appendParam(params, 'policyStatus', filter.policyStatus);
        return fetchRequest_1.fetchRequestWithPagination(Policy_1.getUnderlyingPoliciesUsingGet(filter.masterPolicyNo, params), this.baseUrl);
    };
    /**
     * Get underlying policies from a master policy inlcuding pagination
     * @param partyId
     * @param policyStatus
     * @param apiParams
     */
    PolicyConnector.prototype.getUnderlyingPoliciesByPartyWithPagination = function (partyId, policyStatus, apiParams) {
        var params = new URLSearchParams();
        UrlParam_1.appendDefaultParams(params, apiParams);
        return fetchRequest_1.fetchRequestWithPagination(Policy_1.getUnderlyingPoliciesByPartyUsingGet(partyId, policyStatus, params), this.baseUrl);
    };
    return PolicyConnector;
}());
exports.default = PolicyConnector;
